const SmartphoneSoundType = {
    SMARTPHONE_OPEN: "device_open",
    SMARTPHONE_CLOSE: "device_close",
    NEW_CONTENT: "new_content_buzz",
    SOUND_SMARTPHONE_CLICK: "click",
    SOUND_NPC_SMARTPHONE: null,
    SOUND_SMARTPHONE_CALLING: null
};

export default SmartphoneSoundType;